var _style, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentRecieve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 149 148.5",
    style: {
      enableBackground: "new 0 0 149 148.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF6363;}\n\t.st1{fill:#F4F4FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.1,33.8C2.1,16,16.5,1.6,34.3,1.6h80.5c17.8,0,32.2,14.4,32.2,32.2v80.5c0,17.8-14.4,32.2-32.2,32.2H34.3 c-17.8,0-32.2-14.4-32.2-32.2V33.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.1,103.5c0,0.8,0.3,1.5,0.8,2c0.5,0.5,1.3,0.8,2,0.8h54.4c1,0,2-0.5,2.5-1.4c0.5-0.9,0.5-2,0-2.9 c-0.5-0.9-1.5-1.4-2.5-1.4H50c-0.8,0-1.5,0.3-2,0.8C47.4,102,47.1,102.8,47.1,103.5L47.1,103.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.2,43.5c-0.8,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.3-0.8,2v39.6L59,72.8c-0.6-0.5-1.3-0.8-2.1-0.8 c-0.8,0-1.5,0.4-2,1c-0.5,0.6-0.7,1.4-0.7,2.1c0.1,0.8,0.5,1.5,1.1,2l20,17.2v0c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.1,0.3,0.2 c0.7,0.3,1.4,0.3,2.1,0c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.3-0.2,0.5-0.3l20-17.2v0c0.7-0.7,1.1-1.7,0.9-2.7c-0.2-1-0.9-1.8-1.8-2.1 c-0.9-0.3-2-0.2-2.8,0.4L80,85.9V46.3c0-0.8-0.3-1.5-0.8-2C78.7,43.8,77.9,43.5,77.2,43.5L77.2,43.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRecieve);
export default __webpack_public_path__ + "static/media/payment_recieve.73e92f6e9cceed12593c84bf0bf99751.svg";
export { ForwardRef as ReactComponent };